import axios from 'axios';
import { getEnv } from '../config';

const API_URL = getEnv('REACT_APP_API_URL') || '';

export const userAPI = {
    getUsers: (params) => axios.get(`${API_URL}/api/admin/leaders`, { params }),
    getUser: (id) => axios.get(`${API_URL}/api/admin/leaders/${id}`),
    createUser: (userData) => axios.post(`${API_URL}/api/admin/leaders`, userData),
    updateUser: (id, userData) => axios.put(`${API_URL}/api/admin/leaders/${id}`, userData),
    deleteUser: (id) => axios.delete(`${API_URL}/api/admin/leaders/${id}`),
    getInviteInfo: (token) => axios.get(`${API_URL}/auth/invite/${token}`),
    demoteToMember: (id) => axios.post(`${API_URL}/api/admin/leaders/${id}/demote-to-member`),
    regenerateInvite: (id) => axios.post(`${API_URL}/api/admin/leaders/${id}/regenerate-invite`),
    clearEmail: (id) => axios.post(`${API_URL}/api/admin/leaders/${id}/clear-email`),
    uploadPhoto: (leaderId, file) => {
        const formData = new FormData();
        formData.append('photo', file);
        return axios.post(`${API_URL}/api/admin/leaders/${leaderId}/photo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    // Self-service profile endpoints
    updateProfile: (data) => axios.put(`${API_URL}/api/profile`, data),
    uploadProfilePhoto: (file) => {
        const formData = new FormData();
        formData.append('photo', file);
        return axios.post(`${API_URL}/api/profile/photo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};
